import * as React from 'react';
import { ActionsDropdown, ActionsDropdownArrow, ActionsDropdownItem, Box, Button, ButtonIcon } from '@moosend/mooskin';
import { withLimitNotificationUpgrade } from './PermissionsAndLimitsContext';

const CreateNewListDropdown: React.FC<{
	options?: { label: string; value: string }[];
	onClickNew?: () => void;
	initiateCreateNew: (type: string) => void;
}> = (props) => {
	const [dropdown, setDropdown] = React.useState(false);

	const renderOverlay = () => {
		return <Box position="fixed" top={0} left={0} bottom={0} right={0} onClick={() => setDropdown(false)} />;
	};

	const onActionClick = (type: string) => {
		props.initiateCreateNew && props.initiateCreateNew(type);
	};

	const renderOptions = () => {
		const ActionsDropdownItemWithLimits = withLimitNotificationUpgrade(ActionsDropdownItem, { code: 'transactional.api', value: 0 || 0 });
		return (
			<ActionsDropdown isOpen={dropdown}>
				<ActionsDropdownArrow right={16} boxShadow="base" />
				{props.options?.map((item, i) => (
					<React.Fragment key={i}>
						{item.label !== 'Transactional' && (
							<ActionsDropdownItem
								onClick={() => {
									onActionClick(item.value);
									setDropdown(false);
								}}
							>
								{item.label}
							</ActionsDropdownItem>
						)}
						{item.label === 'Transactional' && (
							<ActionsDropdownItemWithLimits
								onClick={() => {
									onActionClick(item.value);
									setDropdown(false);
								}}
							>
								{item.label}
							</ActionsDropdownItemWithLimits>
						)}
					</React.Fragment>
				))}
			</ActionsDropdown>
		);
	};

	return (
		<>
			<Box
				zIndex={dropdown ? 2 : 'unset'}
				position="relative"
				onMouseEnter={() => props.options && setDropdown(true)}
				onMouseLeave={() => props.options && setDropdown(false)}
				h="100%"
			>
				<Button minW={140} buttonSize="lg" h="100%" p="0" ml={10}>
					<Box
						onClick={props.onClickNew}
						d="flex"
						flexGrow={1}
						fontColor="fontColors.white"
						fontSize="14px"
						h="100%"
						align="center"
						justify="center"
					>
						New
					</Box>
					{props.options && (
						<Box w="45px" d="flex" h="100%" align="center" justify="center" borderRadius="0 3px 3px 0">
							<ButtonIcon d="flex" fontColor="fontColors.white" children={dropdown ? 'expand_less' : 'expand_more'} />
						</Box>
					)}
				</Button>
				<Box position="absolute" top={35} left={0} right={0} pt={20}>
					{renderOptions()}
				</Box>
			</Box>
			{dropdown && renderOverlay()}
		</>
	);
};

export default CreateNewListDropdown;
